import * as React from 'react'
import cn from 'classnames'
import { CheckboxIcon } from 'components/checkbox-icon'
import { components, OptionProps } from 'react-select'
import { TProfileSkillOption } from '../profile-skill-select.types'
import { observer } from 'mobx-react-lite'

export const Option = observer(
  (props: OptionProps<TProfileSkillOption, true>) => {
    const { isSelected, isFocused, label } = props

    return (
      <components.Option
        {...props}
        className={cn(
          isFocused && 'bg-gray-50',
          isSelected && !isFocused && 'bg-transparent',
          'hover:!bg-gray-50 hover:cursor-pointer px-4 py-3 flex flex-row items-center gap-x-2 text-gray-900'
        )}
      >
        <CheckboxIcon checked={isSelected} />
        {label}
      </components.Option>
    )
  }
)
